import { IExperiment } from '../api/experiments';

export const AB_AGENT_EXPERIENCE = 'offer_card_agent_experience';
export const AB_EXPERIENCE_GROUP = 1;

export const isABAgentExperienceExperiment = (experiments: IExperiment[]): boolean => {
  const agentExperienceExperiment = experiments.find(experiment => experiment.name === AB_AGENT_EXPERIENCE);

  const agentExperienceExperimentMatched =
    agentExperienceExperiment && agentExperienceExperiment.abGroup === AB_EXPERIENCE_GROUP;

  return agentExperienceExperimentMatched || false;
};
